import React from "react";
import MiamiVicePage from "./MiamiVicePage";

/**
 * Miami Vice 宇宙 — 与 cyber-uni / noir-uni / pixel-uni 并列的独立主题站入口。
 */
export default function MiamiViceUniPage() {
  return <MiamiVicePage />;
}
